import { render, staticRenderFns } from "./ZlifePetAnalises.vue?vue&type=template&id=ca5b79a8&scoped=true"
import script from "./ZlifePetAnalises.vue?vue&type=script&lang=js"
export * from "./ZlifePetAnalises.vue?vue&type=script&lang=js"
import style0 from "./ZlifePetAnalises.vue?vue&type=style&index=0&id=ca5b79a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5b79a8",
  null
  
)

export default component.exports